import {observable} from 'mobx';

export default class DoubleMassCurve {
  @observable input = {

  }
};


// WEBPACK FOOTER //
// ./src/components/Analysis/Tools/Store/DoubleMassCurveStore.js